import React from 'react'
import { WildImage } from './WildImage'
import * as s from "./Wild.module.scss"
export const leftImageCollection = (posts) => (
  <>
    {posts[0] ? (
      <WildImage
        className={s.leftImg0}
        imgSrc={posts[0].feature_image}
        imgSlug={posts[0].slug}
        size="large"
      />
    ) : null}
    {posts[1] ? (
      <WildImage
        className={s.leftImg1}
        imgSrc={posts[1].feature_image}
        imgSlug={posts[1].slug}
        size="small"
      />
    ) : null}
    {posts[2] ? (
      <WildImage
        className={s.leftImg2}
        imgSrc={posts[2].feature_image}
        imgSlug={posts[2].slug}
        size="small"
      />
    ) : null}
  </>
)

export const centerImageCollection = (posts) => (
  <>
    {posts[0] ? (
      <WildImage
        className={s.centerImg0}
        imgSrc={posts[0].feature_image}
        imgSlug={posts[0].slug}
        size="small"
      />
    ) : null}
    {posts[1] ? (
      <WildImage
        className={s.centerImg1}
        imgSrc={posts[1].feature_image}
        imgSlug={posts[1].slug}
        size="small"
      />
    ) : null}
    {posts[2] ? (
      <WildImage
        className={s.centerImg2}
        imgSrc={posts[2].feature_image}
        imgSlug={posts[2].slug}
        size="large"
      />
    ) : null}
  </>
)

export const rightImageCollection = (posts) => (
  <>
    {posts[0] ? (
      <WildImage
        className={s.rightImg0}
        imgSrc={posts[0].feature_image}
        imgSlug={posts[0].slug}
        size="large"
      />
    ) : null}
    {posts[1] ? (
      <WildImage
        className={s.rightImg1}
        imgSrc={posts[1].feature_image}
        imgSlug={posts[1].slug}
        size="small"
      />
    ) : null}
    {posts[2] ? (
      <WildImage
        className={s.rightImg2}
        imgSrc={posts[2].feature_image}
        imgSlug={posts[2].slug}
        size="small"
      />
    ) : null}
  </>
)
